module.exports = __webpack_public_path__ + "img/billwerk-plus-logo.676baec5.png";